<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="24">
        <p>Export list of all active accounts and investigators with current and predicted account grade</p>
        <el-form
          ref="form"
          :model="form"
          size="small"
        >
          <el-row>
            <el-col>
              <el-button
                type="primary"
                size="small"
                class="float-right"
                @click.native="downloadCSV()"
              >
                Export
              </el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
    <Preview
      v-if="isShowPreview"
      title="Customer Grade Export"
      :is-show.sync="isShowPreview"
      :configuration="configuration"
      :is-direct-download="true"
    />
  </div>
</template>

<script>
import Preview from '@/components/Application/Reports/Preview'

export default {
  components: {
    Preview
  },
  data () {
    return {
      pageTitle: 'Customer Grade',
      breadcrumb: {
        name: 'Customer Grade',
        route: { name: 'reports-customer-grade' }
      },
      form: {},
      isShowPreview: false,
      configuration: null
    }
  },
  methods: {
    downloadCSV () {
      this.configuration = {
        report: 'CustomerGrade',
        params: this.form
      }
      this.isShowPreview = true
    }
  }
}
</script>
